/**
 * Customer Timeline types.
 *
 * Re-exports the core event types from features/events and adds
 * customer-timeline-specific types (CustomerProfile, filter shape).
 */

// Re-export all event types from the reference implementation (2556)
export type {
  PlatformEvent,
  EventFilter,
  EventListResponse,
  EventCategory,
  EventOrigin,
  EventStorage,
  ConnectionState,
} from '@/features/events/types'

export {
  categoryColors,
  categoryHexColors,
  categoryIcons,
  getEventTypeLabel,
  formatCategoryLabel,
  formatOriginLabel,
  formatRelativeTime,
} from '@/features/events/types'

/**
 * Customer profile for the header strip (standalone form).
 */
export interface CustomerProfile {
  id: string
  email: string
  name?: string
  /** Tier / plan identifier, e.g. "pro", "free", "enterprise" */
  tier?: string
  created?: number
}

/**
 * Filter state for the customer timeline.
 * Identical to EventFilter but without the `customerId` facet —
 * the customer is fixed by the route param.
 */
export interface CustomerTimelineFilter {
  /** Search term */
  q?: string
  /** Event type filter (multi-select) */
  type?: string[]
  /** Source service filter (multi-select) */
  source?: string[]
  /** Category filter (multi-select) */
  category?: import('@/features/events/types').EventCategory[]
  /** Time range start */
  from?: string | number
  /** Time range end */
  to?: string | number
}

/**
 * Default time range for customer timelines.
 * Customers have sparser events — 90 days is the right window (vs 24h for global).
 */
export const DEFAULT_TIMELINE_DAYS = 90
